// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"1122b11c","82":"d78c7520","488":"470ac86a","501":"44a9b0d0","759":"81ffaa22"}[chunkId] + ".chunk.js";
};